/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return ServiceAccountStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountStatusQueryOperator>): ServiceAccountStatusQueryOperator {
        let obj = Object.assign(new ServiceAccountStatusQueryOperator(), model);
        ServiceAccountStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountStatusQueryOperator>): ServiceAccountStatusQueryOperator {
        if (!model) return null;
        return ServiceAccountStatusQueryOperator.newInstance(<ServiceAccountStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountStatusQueryOperator) {
        if (!obj) return;

        models.ServiceAccountStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account statuses to include
     */
    statuses: Array<models.ServiceAccountStatus>;

}
